import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

/**
 * Estado global que indica si el backend reportó la sesión como caducada.
 * Cuando es `true`, la UI debe mostrar un modal bloqueante.
 */
@Injectable({ providedIn: "root" })
export class SessionCaducadaService {
	private readonly _caducada$ = new BehaviorSubject<boolean>(false);
	readonly caducada$ = this._caducada$.asObservable();

	get caducada(): boolean {
		return this._caducada$.getValue();
	}

	marcarCaducada(): void {
		if (!this._caducada$.getValue()) {
			this._caducada$.next(true);
		}
	}
}
